module.exports = __webpack_public_path__ + "img/avatar_3.7169d221.jpg";